import {createSelector} from 'reselect'
import {API_KEYS, SETTINGS} from '../../../common/constants/SettingsPanels.js'
import {isNumeric} from '../../../common/utils.js'
import {locationSelector} from '../../../redux/selectors/ui/location.js'
import {NEW_ID} from '../../../common/constants/index.js'

export const apiKeyEditIDSelector = createSelector(
  locationSelector,
  ({pathComponents}) =>
    pathComponents[0] === SETTINGS &&
    pathComponents[1] === API_KEYS &&
    pathComponents[2]
      ? isNumeric(pathComponents[2])
        ? Number(pathComponents[2])
        : pathComponents[2]
      : null,
)

export const apiKeyIsNewSelector = createSelector(
  apiKeyEditIDSelector,
  (editID) => editID === NEW_ID,
)
